import axiosClient from '../../api/axiosClient';

const milestoneModel = {
  state: {
    milestones: [],
    milestoneId: '',
  },
  reducers: {
    setData(state, payload) {
      const { name, data } = payload;
      return { ...state, [name]: data };
    },
  },
  effects: dispatch => ({
    async getMilestones(menteeId) {
      await axiosClient
        .get(`milestones/getMenteeMilestoneData/${menteeId}`)
        .then(res => {
          if (res.status === 200) {
            this.setData({
              name: 'milestones',
              data: [...res.data.data.milestones],
            });
          }
        })
        .catch(err => {
          return err.response;
        });
    },
    async updateMilestone({ menteeId, milestoneId, newValue }) {
      const payload = { menteeId, milestoneId, newValue };
      try {
        const res = await axiosClient.patch('milestones/updateMenteeMilestones', payload);
        return res.status;
      } catch (err) {
        return err.response;
      }
    },
  }),
};

export default milestoneModel;
